export default __webpack_public_path__ + "static/media/contact-us-modern-02.8df481c4.jpg";